import { render, staticRenderFns } from "./ExtensionsPad.vue?vue&type=template&id=709cbe83&scoped=true"
import script from "./ExtensionsPad.vue?vue&type=script&lang=js"
export * from "./ExtensionsPad.vue?vue&type=script&lang=js"
import style0 from "./ExtensionsPad.vue?vue&type=style&index=0&id=709cbe83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709cbe83",
  null
  
)

export default component.exports